import { forwardRef } from "react";
import { IconPropsType, Ref } from "./IconPropsType";

const UnfollowUser = forwardRef<Ref, IconPropsType>(
  ({ color = "currentColor", size, ...rest }, ref) => {
    return (
      <svg
        width={size ?? 20}
        height={size ?? 20}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.99999 1.66666C7.81666 1.66666 6.04166 3.44166 6.04166 5.62499C6.04166 7.76666 7.71666 9.49999 9.89999 9.57499C9.96666 9.56666 10.0333 9.56666 10.0833 9.57499C10.1 9.57499 10.1083 9.57499 10.125 9.57499C10.1333 9.57499 10.1333 9.57499 10.1417 9.57499C12.275 9.49999 13.95 7.76666 13.9583 5.62499C13.9583 3.44166 12.1833 1.66666 9.99999 1.66666Z"
          fill={color}
        />
        <path
          d="M14.2333 11.8C11.9083 10.25 8.11666 10.25 5.775 11.8C4.71666 12.5 4.13333 13.4583 4.13333 14.4833C4.13333 15.5083 4.71666 16.4583 5.76666 17.1583C6.93333 17.9417 8.46666 18.3333 10 18.3333C11.5333 18.3333 13.0667 17.9417 14.2333 17.1583C15.2833 16.45 15.8667 15.5 15.8667 14.4667C15.8583 13.45 15.2833 12.4917 14.2333 11.8ZM11.525 15.0583H8.48333C8.16667 15.0583 7.90833 14.8 7.90833 14.4833C7.90833 14.1667 8.16667 13.9083 8.48333 13.9083H11.525C11.8417 13.9083 12.1 14.1667 12.1 14.4833C12.1 14.8 11.8417 15.0583 11.525 15.0583Z"
          fill={color}
        />
      </svg>
    );
  },
);

export default UnfollowUser;
